import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import GenerateKey from "./components/generationkey/generationkey";
import Sidebar from "./components/Sidbar";
import Key from "./components/generationkey/key";
import Login from "./components/login/Login";
import { useState } from "react";
import NavBar from "../src/components/navbar/NavBar";
import EnterprisesList from "./components/enterprises/List";
import GenerationkeyList from "./components/generationkey/List";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import UserManagement from "./components/usermanagement/UserManagement";
import DashboardComponent from "./components/dashboard/DashboardComponent";
import { createTheme, ThemeProvider } from "@mui/material";


function App() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isAuthRoute = location.pathname === "/";
  const isVideoPage = location.pathname === "/video";
  const isVideoPlayerPage = location.pathname === "/video-player";

  // const PrivateRoute = ({ element }) => {
  //   const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  //   return isAuthenticated ? element : <Navigate to="/" />;
  // };

  return (
    <div>
      {!isAuthRoute && !isVideoPage && !isVideoPlayerPage && (
        <NavBar sidebarOpen={sidebarOpen} />
      )}
      <ThemeProvider theme={Theme}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Login />} />

          <Route
            path="/*"
            element={
              <div style={{ display: "flex" }}>
                <Sidebar
                  setSidebarOpen={setSidebarOpen}
                  sidebarOpen={sidebarOpen}
                />
                <div style={{ padding: "1rem", flex: 1, marginTop: "54px" }}>
                  <Routes>
                    {/* <Route path="/dashboard" element={<DashboardComponent />} /> */}
                    <Route path="/key" element={<Key />} />
                    <Route path="/add-generatekey" element={<GenerateKey />} />
                    <Route path="/enterprises" element={<EnterprisesList />} />
                    <Route
                      path="/usermanagement"
                      element={<UserManagement />}
                    />
                    <Route
                      path="/generatekeys"
                      element={<GenerationkeyList />}
                    />
                  </Routes>
                </div>
              </div>
            }
          />
        </Routes>
        <ToastContainer />
      </ThemeProvider>
    </div>
  );
}

export default App;

const Theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#2566e8", // Light blue for primary in dark mode
    },
    secondary: {
      main: "#f48fb1", // Light pink for secondary in dark mode
    },

    background: {
      background: {
        default: "#ffffff", // Set background color based on dark mode
        // peper: darkMode ? "#121212" : "#F2F4FE", // Set background color based on dark mode
      },
    },
    text: {
      color: "color/base/white",
    },
    border: {
      color: "color/base/white",
    },

    shadows: [
      "none",
      "0px 4px 6px rgba(0, 0, 0, 0.1)", // Subtle shadow
      "0px 6px 12px rgba(0, 0, 0, 0.2)", // Stronger shadow
    ],
  },
  typography: {
    fontFamily: ["Inter"].join(","),
    poster: {
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      letterSpacing: "0.1em",
    },
    subtitle1: {
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      letterSpacing: "0.1em",
      marginBottom: "0.2rem",
    },
    subtitle2: {
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: "600",
      lineHeight: "24px",
      letterSpacing: "0.1em",
    },
    h1: {
      color: "#000",
      fontFamily: "Inter",
      fontSize: "64px",
      fontWeight: "700",
      lineHeight: "144px",
    },
    h2: {
      fontFamily: "Inter",
      fontSize: "64px",
      fontWeight: "600",
      lineHeight: "normal",
    },
    h3: {
      fontFamily: "Inter",
      fontSize: "36px",
      fontWeight: "800",
      lineHeight: "54px",
    },
    h6: {
      fontFamily: "Inter",
      fontSize: "20px",
      fontWeight: "600",
      lineHeight: "28px",
      textAlign: "left",
      textUnderlinePosition: "from-font",
      textDecorationSkipInk: "none",
    },
    h5: {
      fontFamily: "Inter",
      fontSize: "24px",
      fontWeight: "600",
      lineHeight: "29.05px",
      textAlign: "left",
      textUnderlinePosition: "from-font",
      textDecorationSkipInk: "none",
    },
    h7: {
      fontFamily: "Inter",
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "24.3px",
      textAlign: "left",
      textUnderlinePosition: "from-font",
      textDecorationSkipInk: "none",
    },

    body1: {
      fontSize: "16px",
      // fontWeight: "700",
      lineHeight: "21.52px",
      letterSpacing: "-0.02em",
      textTransform: "capitalize",
      fontFamily: "Inter",
      marginBottom: "0.5rem",
    },
    caption: {
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: "600",
      lineHeight: "14.52px",
      letterSpacing: "-0.02em",
      textAlign: "left",
      // textTransform: "capitalize",
    },
    caption1: {
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "normal",
      letterSpacing: "-0.02em",
      textAlign: "left",
    },
    p:{
    fontSize: "20px",
    fontWeight: "400",
    fontFamily: "Inter",
    }
  },
  components: {
    MuiFormControlLabel: {
      "& .MuiFormControlLabel-label": {
        fontSize: "12px",
      },
      styleOverrides: {
        root: {
          marginBottom: "0px", // Removes bottom margin for the root container
        },
        label: {
          marginBottom: "0px", // Removes bottom margin for the label part
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: (theme) => theme.palette.background.default, // Return the value
          borderRadius: "8px",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
          borderRadius: "8px",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
      },
    },
  },
});
